import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import { useSwipeable } from 'react-swipeable';
import './MediaViewer.css';

const MediaViewer = ({ media, initialIndex, onClose }) => {
    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const [offsetX, setOffsetX] = useState(0);
    const [animating, setAnimating] = useState(false);
    const containerRef = useRef(null);

    const handleSwipedHorizontal = (deltaX) => {
        if (deltaX < -50) {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % media.length);
        } else if (deltaX > 50) {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + media.length) % media.length);
        }
        setOffsetX(0);
        setAnimating(true);
        setTimeout(() => setAnimating(false), 300);
    };

    const handlers = useSwipeable({
        onSwiped: (eventData) => {
            handleSwipedHorizontal(eventData.deltaX);
        },
        onSwiping: (eventData) => {
            setOffsetX(eventData.deltaX);
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    return ReactDOM.createPortal(
        <div className="media-viewer-overlay" {...handlers}>
            <div
                className="close-button"
                onClick={e => {
                    e.stopPropagation();
                    onClose();
                }}
            >
                &times;
            </div>
            <div
                ref={containerRef}
                className="media-content-container"
                style={{
                    transform: `translateX(calc(${-currentIndex * 100}% + ${offsetX}px))`,
                    transition: animating ? 'transform 0.3s ease' : 'none',
                    display: 'flex',
                }}
            >
                {media.map((item, index) => (
                    <div key={index} className="media-content" onClick={e => e.stopPropagation()}>
                        {item.type === 'image' ? (
                            <img src={item.src} alt="Media" />
                        ) : (
                            <video src={item.src} controls />
                        )}
                        <div
                            className="close-overlay"
                            onClick={e => {
                                e.stopPropagation();
                                onClose();
                            }}
                        >
                        </div>
                    </div>
                ))}
            </div>
        </div>,
        document.body
    );
};

export default MediaViewer;